<div class="header-helper bold-text" *ngIf="showTicketNumbers">Ticket {{changeRequest.id}}</div>
<div class="cell">
  <div class="grid-y">
    <div *ngFor="let changeKey of changeKeys">
      <div id="no-padding-bottom" class="grid-x" *ngIf="allChanges.get(changeKey).length > 0">
        <div class="cell large-2 medium-4 small-12">
          <span style="color: gray">{{changeKey}}</span>
        </div>
        <div class="cell large-10 medium-8 small-12">
          <div class="grid-x" *ngFor="let change of allChanges.get(changeKey)">
            <div class="cell large-12 medium-12 small-12" [innerHtml]="change"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
